export interface RegionOption {
  key: string;
  label: string;
  emoji: string;
}

export const REGION_OPTIONS: RegionOption[] = [
  { key: "nordics_no", label: "Norway", emoji: "🇳🇴" },
  { key: "nordics_fi", label: "Finland", emoji: "🇫🇮" },
  { key: "nordics_se", label: "Sweden", emoji: "🇸🇪" },
  { key: "nordics_dk", label: "Denmark", emoji: "🇩🇰" },
  { key: "dach_de", label: "Germany", emoji: "🇩🇪" },
  { key: "dach_at", label: "Austria", emoji: "🇦🇹" },
  { key: "dach_ch", label: "Switzerland", emoji: "🇨🇭" },
  { key: "benelux_nl", label: "Netherlands", emoji: "🇳🇱" },
  { key: "benelux_be", label: "Belgium", emoji: "🇧🇪" },
  { key: "southern_fr", label: "France", emoji: "🇫🇷" },
  { key: "southern_es", label: "Spain", emoji: "🇪🇸" },
  { key: "southern_it", label: "Italy", emoji: "🇮🇹" },
  { key: "british_uk", label: "United Kingdom", emoji: "🇬🇧" },
  { key: "na_us", label: "United States", emoji: "🇺🇸" },
];

/** Map from region_key to { label, emoji } for quick lookups */
export const REGION_MAP: Record<string, { label: string; emoji: string }> =
  Object.fromEntries(REGION_OPTIONS.map((r) => [r.key, { label: r.label, emoji: r.emoji }]));

/** Get display info for a region key, with fallback */
export function getRegionDisplay(regionKey: string | null): { label: string; emoji: string } {
  if (!regionKey) return { label: "Global", emoji: "🌐" };
  return REGION_MAP[regionKey] || { label: regionKey, emoji: "🏳️" };
}

/** Get just the flag emoji for a region key */
export function regionToFlag(key?: string | null): string {
  if (!key) return "🌍";
  return REGION_MAP[key]?.emoji || "🌍";
}
